import { useTranslation } from 'react-i18next'

import { ScrollableTabs, Text } from '@reveni-io/reveni-ui'

import useTabsSearchParam from '@/configuration/pages/ConfigurationPage/hooks/useTabsSearchParam/useTabsSearchParam'
import AvailabilityCriteriaTab from '@/configuration/pages/ConfigurationPage/LogisticsConfiguration/components/AvailabilityCriteriaTab/AvailabilityCriteriaTab'
import configurationServices from '@/configuration/services/services'
import routes from '@/Router/routes.constants'

import DeliveryMethodsTab from './DeliveryMethodsTab/DeliveryMethodsTab'
import { deliveryMethodsTabList, deliveryMethodsTabs } from './constants'
import * as Styles from './styles'

const DeliveryMethodsConfiguration = () => {
  const { t } = useTranslation()

  const tabs = deliveryMethodsTabList.map(tab => ({ ...tab, label: t(tab.label) }))

  const { activeTab, onChangeTab } = useTabsSearchParam({
    tabs,
    defaultTab: deliveryMethodsTabs.deliveryMethods,
  })

  return (
    <Styles.Container>
      <Text type="bodyMRegular">
        {t(
          'Define los métodos que los clientes pueden elegir para devolver sus productos, y sus criterios de disponibilidad'
        )}
        :
      </Text>
      <ScrollableTabs tabs={tabs} value={activeTab} onChange={onChangeTab} />
      {activeTab === deliveryMethodsTabs.deliveryMethods && <DeliveryMethodsTab />}
      {activeTab === deliveryMethodsTabs.availabilityCriteria && (
        <AvailabilityCriteriaTab
          getAvailabilityCriteria={configurationServices.getAvailabilityCriteria}
          reorderAvailabilityCriteria={configurationServices.reorderAvailabilityCriteria}
          deleteAvailabilityCriterion={configurationServices.deleteAvailabilityCriterion}
          detailRoute={routes.configurationPage.logistics.availabilityCriterionDetail}
        />
      )}
    </Styles.Container>
  )
}

export default DeliveryMethodsConfiguration
